// extracted by mini-css-extract-plugin
export default {"footer":"OrderSummaryModal_footer__2rhYC","list":"OrderSummaryModal_list__KJL4C","info":"OrderSummaryModal_info__DvnSD","tracking_number":"OrderSummaryModal_tracking_number__1voM8"};